import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { width: "100%" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = {
  key: 0,
  class: "text-left"
}
const _hoisted_6 = {
  key: 1,
  class: "text-left"
}
const _hoisted_7 = {
  key: 2,
  class: "text-right"
}
const _hoisted_8 = {
  key: 3,
  class: "text-right"
}
const _hoisted_9 = {
  key: 4,
  class: "text-right"
}
const _hoisted_10 = {
  key: 5,
  class: "text-right"
}
const _hoisted_11 = {
  key: 6,
  class: "text-center"
}
const _hoisted_12 = {
  key: 7,
  class: "text-center"
}
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = {
  key: 0,
  align: "center",
  style: {"max-width":"30px"}
}
const _hoisted_17 = {
  key: 1,
  align: "center",
  style: {"cursor":"pointer"}
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { align: "right" }
const _hoisted_20 = {
  key: 2,
  align: "center",
  style: {"max-width":"60px"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { class: "pt-2 pl-2 d-flex space-x-1" }
const _hoisted_24 = { class: "d-flex align-center justify-center" }
const _hoisted_25 = { class: "w-100" }
const _hoisted_26 = { style: {"width":"90vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip_tag = _resolveComponent("v-chip-tag")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_ossDatePicker_filled = _resolveComponent("ossDatePicker-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_PaymentManagement = _resolveComponent("PaymentManagement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode !== 'Payment' && _ctx.isAccountingUser)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_data_table, {
                key: 0,
                headers: _ctx.headers,
                items: _ctx.filteredAccountingLines,
                "fixed-header": "",
                "max-height": "60vh",
                border: "",
                "items-per-page": -1,
                density: "compact",
                class: "table"
              }, {
                item: _withCtx((props) => [
                  _createElementVNode("tr", {
                    class: _normalizeClass(props.item.selected ? 'info' : '')
                  }, [
                    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getItemAccountableAccountTitle(props.item)), 1),
                    _createElementVNode("td", _hoisted_4, [
                      (props.item.tag)
                        ? (_openBlock(), _createBlock(_component_v_chip_tag, {
                            key: 0,
                            color: "tagFree",
                            class: "text mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.tag.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (props.item.tags)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.item.tags, (tag, index) => {
                            return (_openBlock(), _createBlock(_component_v_chip_tag, {
                              ripple: false,
                              key: index,
                              class: "text mr-1"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                }, _toDisplayString(tag.name), 5)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(props.item.wording), 1)
                    ]),
                    (
                            !_ctx.isShortScreen)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.getThirdPartyName(props.item)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.showDueDateColumn)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.formatDate(props.item.dueDate)), 1))
                      : _createCommentVNode("", true),
                    (props.item.debit)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.debit, undefined)), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_8, "-")),
                    (props.item.credit)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.credit, undefined)), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_10, "-")),
                    (props.item.reconciliationCallToAction)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createVNode(_component_v_btn, {
                            elevation: "0",
                            onClick: ($event: any) => (_ctx.openReconciliation(props.item)),
                            size: "x-small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.reconciliationCallToAction), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            size: "large"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("$dot")
                            ])),
                            _: 1
                          })
                        ]))
                  ], 2)
                ]),
                "body.append": _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: _ctx.containsThirdParty ? 4 : 2
                    }, null, 8, _hoisted_13),
                    _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-right" }, [
                      _createElementVNode("strong", null, "Total")
                    ], -1)),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalDebit, undefined)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalCredit, undefined)), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"]))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { style: {"background":"transparent"} }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingLines, (item, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: index,
                          class: "my-1 mx-0",
                          ripple: false
                        }, {
                          append: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                                    _ctx.getAmount(item) > 0
                                        ? 'font-weight-bold primary--text'
                                        : 'text-red font-weight-bold'
                                )
                            }, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.getAmount(item), undefined)), 3)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "wrapper" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", {
                                  class: _normalizeClass(_ctx.extendedMode ? '' : 'text-wrapped')
                                }, _toDisplayString(item.wording), 3)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getItemAccountableAccountTitle(item)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getThirdPartyName(item)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.extendedMode)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                  key: 0,
                                  class: "mt-2 d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "small",
                                      location: "start"
                                    }, {
                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode("$oss-calendar")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(item.dueDate)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.mode === 'Payment')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.detailHeaders,
            items: _ctx.filteredAccountingLines,
            class: "table",
            striped: true,
            dense: true,
            "fixed-header": "",
            "checkbox-color": "primary"
          }, {
            item: _withCtx((props) => [
              _createElementVNode("tr", null, [
                (_ctx.candidateForPaymentAccountingLineCount)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                      (props.item.paymentStatus === 'TODO')
                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                            key: 0,
                            icon: 
                                    props.item.selected
                                        ? '$oss-circle-check'
                                        : '$oss-circle-uncheck'
                                ,
                            size: "x-small",
                            onClick: _withModifiers(($event: any) => (props.item.selected = !props.item.selected), ["stop"]),
                            "data-cy": "AccountingItemStatic-selectioner"
                          }, null, 8, ["icon", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getItemAccountableAccountTitle(props.item)), 1)
                ]),
                (_ctx.showDueDateColumn)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                      (!!props.item.paymentStatus)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.opendueDateToEditDialog(props.item)), ["stop"])
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.getDueDate(props.item)) + " ", 1),
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode(" $oss-edit ")
                              ])),
                              _: 1
                            })
                          ], 8, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass(
                                    _ctx.getAmount(props.item) > 0
                                        ? 'font-weight-bold primary--text'
                                        : 'text-red font-weight-bold'
                                )
                  }, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.getAmount(props.item), undefined)), 3)
                ]),
                (_ctx.candidateForPaymentAccountingLineCount)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                      (props.item.paymentStatus)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            label: "",
                            class: "px-1",
                            color: props.item.paymentStatus === 'DONE' ? 'secondary' : 'red',
                            size: "x-small",
                            variant: "outlined"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getPaymentStatusTitle(props.item)), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showTags)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                    _createElementVNode("td", {
                      colspan: 
                                _ctx.showDueDateColumn
                                    ? _ctx.candidateForPaymentAccountingLineCount
                                        ? 4
                                        : 3
                                    : _ctx.candidateForPaymentAccountingLineCount
                                      ? 3
                                      : 2
                            
                    }, [
                      _createVNode(_component_FreeTag, {
                        companyTags: _ctx.allCompanyTags,
                        company: _ctx.selectedCompany,
                        documentType: _ctx.type,
                        accountingLine: props.item
                      }, null, 8, ["companyTags", "company", "documentType", "accountingLine"])
                    ], 8, _hoisted_22)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["headers", "items"]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_ctx.toPayAccountingLineCount)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    rounded: "",
                    disabled: !_ctx.selectedAccountingLinesForPayment.length,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.payDialog = true), ["stop"])),
                    elevation: "0",
                    "data-cy": "AccountingItemStatic-paiement",
                    size: "x-small"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Gérer le paiement ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.showTags,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTags) = $event)),
                density: "compact",
                elevation: "0",
                "hide-details": "",
                class: "pl-2",
                label: "Afficher les étiquettes"
              }, null, 8, ["modelValue"])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: 'Supprimer les opérations diverses',
      onValid: _ctx.deleteDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[17] || (_cache[17] = [
        _createElementVNode("div", { class: "body-1" }, " Êtes-vous sur de vouloir supprimer les opérations diverses ? ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    (_ctx.dueDateDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 2,
          modelValue: _ctx.dueDateDialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dueDateDialog) = $event)),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dueDateDialog = false)),
          title: 'Edition échéance',
          width: _ctx.$vuetify.display.mobile ? '100wv' : '50wv'
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              rounded: "",
              block: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateAccountingLineDueDate())),
              disabled: !_ctx.dueDateValid,
              size: "x-large"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("Modifier")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.dueDateValid,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dueDateValid) = $event)),
              class: "w-100 pb-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ossDatePicker_filled, {
                    modelValue: _ctx.dueDateToEdit,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dueDateToEdit) = $event)),
                    "hide-details": "",
                    textFieldReadOnly: false,
                    notRequired: true
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "width"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editDialog) = $event)),
      actions: _ctx.actionsEditionDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.editDialog)
            ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                key: 0,
                companyId: _ctx.companyId,
                documentId: _ctx.documentId,
                actions: _ctx.actionsEditionDialog,
                onUpsert: _ctx.onUpsert
              }, null, 8, ["companyId", "documentId", "actions", "onUpsert"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "actions"]),
    (_ctx.payDialog)
      ? (_openBlock(), _createBlock(_component_PaymentManagement, {
          key: 3,
          modelValue: _ctx.payDialog,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payDialog) = $event)),
          companyId: _ctx.companyId,
          inInvoiceNumber: _ctx.invoiceNumber,
          accountingLines: _ctx.selectedAccountingLinesForPayment,
          forCustomer: _ctx.isForCustomer,
          onActionDone: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refresh()))
        }, null, 8, ["modelValue", "companyId", "inInvoiceNumber", "accountingLines", "forCustomer"]))
      : _createCommentVNode("", true)
  ]))
}